<template>
  <el-popover popper-class="server-popover" trigger="hover" :width="300" v-bind="$attrs" v-on="$listeners">
    <template slot="reference"></template>
    <slot slot="reference"></slot>
    <div class="server-title">联系客服，立即付费推广</div>
    <YorkbbsImage class="server-qrcode" :src="require('@/assets/images/common/qrcode-service.png')"></YorkbbsImage>
    <div class="server-concat__list">
      <div class="server-concat__item">
        <div class="server-concat__name">
          <i class="yk-house_wechat1"></i>
          <span>YorkbbsAD</span>
        </div>
        <button
          class="service-concat__button"
          v-clipboard:copy="'YorkbbsAD'"
          v-clipboard:success="() => $success('复制成功')"
        >
          <i></i>
          <span>复制微信号</span>
        </button>
      </div>
      <div class="server-concat__item">
        <div class="server-concat__name">
          <i class="yk-phone-o"></i>
          <span>416-915-5056</span>
        </div>
        <div class="server-concat__name">
          <i></i>
          <span>416-628-9108</span>
        </div>
      </div>
    </div>
  </el-popover>
</template>
<script>
export default {
  name: 'PopoverServer',
};
</script>
<style lang="scss" scoped>
.server-title {
  text-align: center;
  font-size: 15px;
  line-height: 21px;
  color: var(--text-color-9);
  padding-top: 20px;
  padding-bottom: 10px;
}
.server-qrcode {
  width: 150px;
  height: 150px;
  margin: auto;
  margin-bottom: 15px;
}
.server-concat__list {
  margin: 0 10px;
  padding: 15px 18px 20px;
  border-top: 1px solid #eee;
  display: flex;
  justify-content: space-between;
}
.server-concat__name {
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  margin-bottom: 5px;
  i {
    display: inline-block;
    width: 20px;
  }
}
.service-concat__button {
  font-size: 12px;
  line-height: 17px;
  color: var(--text-color-9);
  &:hover {
    color: var(--text-color-3);
  }
  i {
    display: inline-block;
    width: 20px;
  }
}
</style>
